import { ChainConstants } from 'constants/ChainConstants';
import { useAElfContract } from 'contexts/useAElfContract/hooks';

export function useTokenContract() {
  const tokenContract = useAElfContract(ChainConstants.constants.tokenContract);
  return tokenContract;
}
